module.exports = __webpack_public_path__ + "img/mobile-update.8ebb6408.svg";